// @ts-check

export class UpdateManager {
  constructor({ buildId, save, restoreRoute }) {
    this.buildId = buildId;
    this.save = save;
    this.restoreRoute = restoreRoute;
    this.channel =
      "BroadcastChannel" in window
        ? new BroadcastChannel("brawnyai-sudoku-updates")
        : null;
    this.reloading = false;
  }
  async start() {
    if (!("serviceWorker" in navigator)) return;
    this.registration = await navigator.serviceWorker.register(
      `./sw.js?build=${encodeURIComponent(this.buildId)}`,
      { scope: "./", updateViaCache: "none" },
    );
    this.channel?.addEventListener("message", (event) => {
      if (event.data?.type === "reload" && event.data.buildId !== this.buildId)
        this.activate(event.data.buildId);
    });
    window.addEventListener("storage", (event) => {
      if (
        event.key === "brawnyai-sudoku-update" &&
        event.newValue !== this.buildId
      )
        this.activate(event.newValue);
    });
    window.addEventListener("online", () => this.check());
    window.addEventListener("pageshow", () => this.check());
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") this.check();
    });
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!this.reloading) return;
      if (this.pendingBuildId)
        localStorage.setItem("brawnyai-sudoku-activated", this.pendingBuildId);
      location.reload();
    });
    await this.check();
    this.interval = window.setInterval(() => {
      if (document.visibilityState === "visible" && navigator.onLine)
        this.check();
    }, 60_000);
  }
  async check() {
    if (!navigator.onLine) return;
    try {
      await this.registration?.update();
      const response = await fetch(`./version.json?check=${Date.now()}`, {
        cache: "no-store",
      });
      if (!response.ok) return;
      const version = await response.json();
      if (
        version.build_id &&
        version.build_id !== this.buildId &&
        localStorage.getItem("brawnyai-sudoku-activated") !== version.build_id
      )
        await this.activate(version.build_id);
    } catch (error) {
      console.debug("Update check deferred", error);
    }
  }
  async activate(nextBuildId) {
    if (!nextBuildId || nextBuildId === this.buildId || this.reloading) return;
    this.reloading = true;
    this.pendingBuildId = nextBuildId;
    await this.save();
    localStorage.setItem(
      "brawnyai-sudoku-emergency",
      JSON.stringify({
        route: this.restoreRoute(),
        saved_at: new Date().toISOString(),
        next_build_id: nextBuildId,
      }).slice(0, 50_000),
    );
    localStorage.setItem("brawnyai-sudoku-update", nextBuildId);
    this.channel?.postMessage({ type: "reload", buildId: nextBuildId });
    const waiting = await this.waitForWaiting();
    if (waiting) waiting.postMessage({ type: "SKIP_WAITING" });
    window.setTimeout(() => location.reload(), waiting ? 5_000 : 0);
  }

  async waitForWaiting(timeout = 8_000) {
    if (this.registration?.waiting) return this.registration.waiting;
    const registration = this.registration;
    if (!registration) return null;
    return new Promise((resolve) => {
      let settled = false;
      let timer;
      const finish = (worker = null) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(worker);
      };
      const watch = (worker) => {
        if (!worker) return;
        if (worker.state === "installed") return finish(worker);
        worker.addEventListener("statechange", () => {
          if (worker.state === "installed") finish(worker);
          if (worker.state === "redundant") finish(null);
        });
      };
      watch(registration.installing);
      registration.addEventListener("updatefound", () =>
        watch(registration.installing),
      );
      timer = window.setTimeout(() => finish(registration.waiting), timeout);
    });
  }
}
